import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// The PR detail page folded into the workflow page's master-detail panel, so the old
// /pull-request/:prNumber URLs now just deep-link into the page via the `pr` query param.
const PullRequestRedirect: React.FC = () => {
  const { prNumber } = useParams<{ prNumber: string }>();
  const target = prNumber ? `/pull-requests?pr=${encodeURIComponent(prNumber)}` : '/pull-requests';
  return <Navigate to={target} replace />;
};

export default PullRequestRedirect;
